<template>
  <div class="w-full h-full">
    <div class="mb-2 w-full min-h-96 relative">
      <label class="hidden flex flex-row font-bold text-left ml-4 px-2.5 text-center block mb-2 text-lg text-gray-900 ">
        <div class="w-full">{{ labels["LABEL_RECIPE_TITLE"][lg] }}</div>
      </label>

      <div>
        <div class="w-full flex">
          <div class="w-full border">
            <div class="mb-2 w-full py-2 flex justify-end" role="group">
              <button
                type="button"
                class="ml-2 flex items-center justify-left px-4 py-2 text-sm font-medium text-white rounded-lg bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300   focus:outline-none "
                @click="onOpenCreateSection"
              >
                <i class="ml-2 fa-solid fa-plus" />
                AJOUTER SECTION
              </button>
            </div>

            <div v-for="section in sections" :key="section.id" class="w-full mb-6">
              <div class="h-8 bg-gray-300 w-full flex flex-row justify-between items-center px-3 font-bold">
                <div class="w-auto flex flex-row w-48 items-center justify-end">
                  <div>{{ section.name }}</div>
                  <div class="flex flex-row items-center">
                    <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                      <div href="#" class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none" @click="onClickSectionEdit(section)">
                        <i class="fa-solid fa-pen" />
                      </div>
                    </div>
                    <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                      <div href="#" class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none" @click="onClickSectionDelete(section)">
                        <i class="fa-solid fa-xmark" />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="flex items-center justify-left px-4 py-1 my-1 text-xs font-medium text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-1 focus:ring-blue-300   focus:outline-none "
                  @click="onOpenList(section)"
                >
                  <i class="fa-solid fa-plus mr-2" />
                  AJOUTER
                </button>
              </div>

              <draggable
                ghost-class="ghost"
                class="w-full min-h-48 border-1 border-solid items-start flex flex-col bg-white mb-1 border-gray-300 p-6"
                :list="section.lines"
                item-key="id"
                @start="drag = true"
                @end="drag = false"
              >
                <template #item="{ element, index }">
                  <div
                    class="cursor-pointer list-group mt-2 w-full bg-gray-50 border border-gray-200 rounded-lg shadow   flex flex-row justify-center"
                    :class="{ 'border-blue-600 border-3': selectedItem == index, 'border-gray-2s00': selectedItem != index }"
                    @click="onSelectItem(index)"
                  >
                    <div class="flex flex-col items-center w-full pl-2">
                      <div class="h-12 flex flex-row items-center w-full pr-6 py-3 mb-3 mt-2">
                        <div class="w-full flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 pr-2 text-sm" viewBox="0 0 320 512">
                            <path
                              d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
                            />
                          </svg>
                          <label class="w-full pr-3 max-w-64 text-ellipsis text-left block text-sm font-bold text-gray-900 ">
                            {{ element.name }}
                          </label>
 
                          <label class="w-full pr-3 text-ellipsis text-left block text-xs font-normal text-gray-500 truncate ">
                            <div class="w-full max-h-12 overflow-hidden text-xs text-gray-500  whitespace-pre-line leading-snug line-clamp-3">
                              {{ element.description }}
                            </div>
                          </label>

                          <div class="w-36 flex flex-row mr-3">
                            <span class="inline-flex items-center px-3 text-sm text-gray-900">
                              <svg
                                class="w-6 h-6 "
                                :class="{ 'text-gray-300': element?.controls?.length == 0, 'text-blue-500': element?.controls?.length > 0 }"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M12 2c-.791 0-1.55.314-2.11.874l-.893.893a.985.985 0 0 1-.696.288H7.04A2.984 2.984 0 0 0 4.055 7.04v1.262a.986.986 0 0 1-.288.696l-.893.893a2.984 2.984 0 0 0 0 4.22l.893.893a.985.985 0 0 1 .288.696v1.262a2.984 2.984 0 0 0 2.984 2.984h1.262c.261 0 .512.104.696.288l.893.893a2.984 2.984 0 0 0 4.22 0l.893-.893a.985.985 0 0 1 .696-.288h1.262a2.984 2.984 0 0 0 2.984-2.984V15.7c0-.261.104-.512.288-.696l.893-.893a2.984 2.984 0 0 0 0-4.22l-.893-.893a.985.985 0 0 1-.288-.696V7.04a2.984 2.984 0 0 0-2.984-2.984h-1.262a.985.985 0 0 1-.696-.288l-.893-.893A2.984 2.984 0 0 0 12 2Zm3.683 7.73a1 1 0 1 0-1.414-1.413l-4.253 4.253-1.277-1.277a1 1 0 0 0-1.415 1.414l1.985 1.984a1 1 0 0 0 1.414 0l4.96-4.96Z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </span>
                            <span :class="{ 'text-gray-300': element?.controls?.length == 0, 'text-blue-500': element?.controls?.length > 0 }">
                              {{ element.controls.length }}
                            </span>
                          </div>

                          <div class="w-48 flex flex-row mr-3">
                            <span class="inline-flex items-center px-3 text-sm text-gray-900">
                              <svg
                                class="w-6 h-6 text-gray-500 "
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </span>
                            <span>{{ element.duration }} h</span>
                          </div>

                          <div class="w-48 flex flex-row">
                            <span class="inline-flex items-center px-3 text-sm text-gray-900">
                              <svg class="w-6 h-6 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                <path
                                  fill-rule="evenodd"
                                  d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm7.25-2.095c.478-.86.75-1.85.75-2.905a5.973 5.973 0 0 0-.75-2.906 4 4 0 1 1 0 5.811ZM15.466 20c.34-.588.535-1.271.535-2v-1a5.978 5.978 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2h-4.535Z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </span>

                            {{ element.workload }} h
                          </div>
                        </div>
                        <div class="ml-6 w-auto flex w-48 items-center justify-end">
                          <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                            <div href="#" class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none" @click="onClickEdit(section, element)">
                              <i class="fa-solid fa-pen" />
                            </div>
                          </div>
                          <div class="w-auto flex w-full items-center justify-end w-16 px-3">
                            <div href="#" class="flex justify-end cursor-pointer text-gray-800 hover:text-gray-900 font-bold text-lg focus:outline-none" @click="onClickDelete(section, element)">
                              <i class="fa-solid fa-xmark" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
//import Multiselect from '@vueform/multiselect'
import labels from "@/assets/lg/content-composer.json";

import { Modal } from "flowbite";

export default {
  name: "ContentRecipeComposerNew",
  components: {
    draggable,
  },
  props: {
    id: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    required: Boolean,
    value: { type: Object, default: null },
    parent: { type: Object, default: null },
    config: { type: Object, default: null },
  },
  emits: ["action"],
  data() {
    return {
      output: [],
      reference: {
        value: "10",
        unit: "kg",
      },
      filtered: {},
      labels: labels,
      lg: "FR",
      refresh: " ",
      item_to_delete: null,
      drag: false,
      products: [],
      item: {},
      confirmModal: null,

      itemSection: {
        id: "",
        name: "Quantité",
      },

      sections: [],
      lines: [],
      mode: "stock",
      enabled: true,
      selectedLang: "fr",
      selectedItem: null,
      dragging: false,
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
  },
  watch: {
    parent: async function () {
      this.lines = this.sections;
    },

    sections: function () {},
    value: function (val) {
      this.sections = val;
    },
  },
  mounted() {
    this.sections = this.value;

    const modalEl2 = document.getElementById("select-recipe-step-confirm-delete-modal");
    this.confirmModal = new Modal(modalEl2, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });
  },

  methods: {
    onOpenCreateSection: function () {
      this.$emit("action", { type: "manufacturing-step-creation", attribute: this.config?.data });
    },

    onValueChanged: function (val) {
      this.lines[val.index].quantity = val.value;
    },

    onValueTotalChanged: function (val) {
      this.reference = val.value;
    },

    onSwitchChange: async function (id) {
      if (this.lines[this.selectedItem].products == undefined) this.lines[this.selectedItem].products = {};
      this.lines[this.selectedItem].products[id] = this.filtered[id];
    },

    updateSupplierProducts: async function () {},

    onSelectItem: async function () {
      // this.selectedItem = index
      // await this.updateSupplierProducts(this.lines[index].type_id)
    },

    getIndex: function (id) {
      let index = this.lines.findIndex(function (el) {
        return el.id == id;
      });

      return index;
    },
    selectLanguage: function (lg) {
      this.selectedLang = lg;
    },

    getData() {
      return this.sections;
    },

    onOpenList: function (section) {
      let event = {
        type: "manufacturing-process-add-step",
        attribute: this.config.data,
        parent_id: section.id,
        sub_attribute: "lines",
      };
      this.$emit("action", event);
    },

    onClickSectionEdit: function (section) {
      let event = {
        type: "manufacturing-process-edit-section",
        attribute: this.config.data,
        item_id: section.id,
        name: section.name,
      };
      this.$emit("action", event);
    },

    selectValue: function (tag, unit) {
      //this.output = a

      let index = this.getIndex(tag);
      if (this.lines[index] == undefined) this.lines[index] = { unit: "" };
      this.lines[index].unit = unit;
    },
    onClickEdit: function (parent, item) {
      let event = {
        type: "manufacturing-process-edit-step",
        attribute: this.config.data,
        parent_id: parent.id,
        item_id: item.id,
        sub_attribute: "lines",

        name: item.name,
        description: item.description,
        duration: item.duration,
        workload: item.workload,
        controls: item.controls,
      };
      this.$emit("action", event);
    },

    onConfirmClose: function () {
      this.confirmModal.hide();
      this.item_to_delete = null;
    },

    onClickSectionDelete: function (item) {
      this.item_to_delete = item;

      this.$emit("action", {
        type: "manufacturing-process-delete-section",

        name: item.name,

        attribute: this.config.data,

        item_id: item.id,
      });
    },
    onClickDelete: function (parent, item) {
      this.item_to_delete = item;

      this.$emit("action", {
        type: "manufacturing-process-delete-step",

        name: item.name,

        attribute: this.config.data,
        parent_id: parent.id,
        item_id: item.id,
        sub_attribute: "lines",
      });
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.not-draggable {
  cursor: no-drop;
}
</style>
